var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12ZM11.2511 7.50357L11.2586 12.6588C11.2592 13.1111 11.464 13.539 11.8158 13.8233L15.6125 16.8916C15.873 17.1021 16.2434 17.1077 16.5102 16.9053C16.8865 16.6196 16.8953 16.0567 16.528 15.7595L13.3491 13.1874C13.0004 12.9052 12.7962 12.4819 12.7926 12.0334L12.756 7.49641C12.7527 7.08321 12.4168 6.75 12.0036 6.75C11.5876 6.75 11.2505 7.08756 11.2511 7.50357Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3849b6ad25d0056bae39abf1f86ce3dc.svg";
export { ForwardRef as ReactComponent };